import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {CouponUsage, CouponQueryResponse} from './_models'
import {getToken} from '../../../../auth/core/AuthHelpers'

const API_URL = process.env.REACT_APP_API_URLS

const getCouponUsage = (query: string): Promise<CouponQueryResponse> => {
  return axios
    .get(`${API_URL}/coupons/usage/query?${query}`, getToken())
    .then((d: AxiosResponse<CouponQueryResponse>) => {
      
      return d.data
    })
}

export {getCouponUsage}
